export default __webpack_public_path__ + "static/screeny-130-gpz-i-1-ce3696a61d27b1ab1e6622cc8efabf4b.jpg";